


































































import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import ClipButton from "@/components/Molecules/ClipButton/index.vue";
import TableOfContents from "@/components/Molecules/TableOfContents/index.vue";
import GrayBox from "@/components/Molecules/GrayBox/index.vue";
import ClipMixin from "@/components/Mixins/Clip/index";
import { Data, Methods, Computed, Props } from "./types";
import { EventPurpose, EventCategory } from "@/api/types";
import { fullWidthToHalfWidthSpace } from "@/helpers/format-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventExperienceCard",
  components: {
    Heading,
    Body,
    ClipButton,
    TableOfContents,
    GrayBox
  },
  mixins: [ClipMixin],
  props: {
    eventExperience: {
      type: Object as PropType<Props["eventExperience"]>,
      required: true
    }
  },
  data() {
    return {
      clipped: false,
      fullWidthToHalfWidthSpace
    };
  },
  computed: {
    eventPurpose() {
      const eventPurpose = this.$route.query["eventPurpose"];
      if (typeof eventPurpose !== "string") {
        return;
      }
      const isValid = Object.values(EventPurpose).includes(
        eventPurpose as EventPurpose
      );
      return isValid ? (eventPurpose as EventPurpose) : undefined;
    },
    eventCategory() {
      const eventCategory = this.$route.query["eventCategory"];
      if (typeof eventCategory !== "string") {
        return;
      }
      const isValid = Object.values(EventCategory).includes(
        eventCategory as EventCategory
      );
      return isValid ? (eventCategory as EventCategory) : undefined;
    },
    eventExperienceDescriptions() {
      const slice = {
        [EventPurpose.Intern.toString()]: {
          [EventCategory.Empty.toString()]: [
            "インターンの形式",
            "インターン期間",
            "参加学生数"
          ],
          [EventCategory.Interview.toString()]: ["面接会場", "面接時間"],
          [EventCategory.WebExamination.toString()]: [
            "実施場所",
            "面接時間",
            "形式"
          ],
          [EventCategory.PaperExamination.toString()]: [
            "実施場所",
            "面接時間",
            "形式"
          ],
          [EventCategory.GroupDiscussion.toString()]: [
            "面接時間",
            "面接官の人数",
            "学生の人数"
          ],
          [EventCategory.JobSelection.toString()]: ["面接会場", "面接時間"]
        },
        [EventPurpose.Recruitment.toString()]: {
          [EventCategory.Event.toString()]: ["面接時間"],
          [EventCategory.Interview.toString()]: ["面接会場", "面接時間"],
          [EventCategory.ObInterview.toString()]: ["連絡の仕方", "訪問人数"],
          [EventCategory.JobSelection.toString()]: ["面接会場", "面接時間"],
          [EventCategory.Recruiter.toString()]: ["面接会場", "面接官の人数"],
          [EventCategory.WebExamination.toString()]: [
            "実施場所",
            "面接時間",
            "形式"
          ],
          [EventCategory.Prehire.toString()]: [
            "内定時期",
            "承諾検討期間",
            "承諾/辞退"
          ],
          [EventCategory.PaperExamination.toString()]: [
            "実施場所",
            "面接時間",
            "形式"
          ],
          [EventCategory.GroupDiscussion.toString()]: [
            "面接時間",
            "面接官の人数",
            "学生の人数"
          ]
        }
      };

      if (!this.eventExperience) {
        return [];
      }

      const tableContents = this.eventExperience.experience_contents
        .table_contents;
      let slicer: string[] = [];
      if (this.eventPurpose) {
        if (this.eventCategory) {
          slicer = slice[this.eventPurpose][this.eventCategory];
        } else {
          slicer = slice[this.eventPurpose][EventCategory.Empty];
        }
        const slicedTableContents = tableContents.filter(content =>
          slicer.includes(content.label)
        );
        return slicedTableContents;
      }

      return tableContents.slice(0, 3);
    },
    eventExperienceBody() {
      if (!this.eventExperience) {
        return "";
      }
      const textContents = this.eventExperience.experience_contents
        .text_contents;
      const combinedText = textContents.map(content => {
        return `【${content.label}】${content.value}`;
      });
      return combinedText.join(" ");
    },
    tableOfContents() {
      if (!this.eventExperience) return [];
      return this.eventExperience.selection_report.selection_report_items?.map(
        e => {
          return {
            label: e.item_type
          };
        }
      );
    }
  },
  watch: {
    "eventExperience.clip_id": {
      immediate: true,
      deep: true,
      handler(val) {
        this.clipped = Boolean(val);
      }
    }
  },
  methods: {
    toggleClipped(clipped) {
      if (!this.eventExperience) return;
      this.clipped = clipped;
      if (clipped && this.eventExperience.id) {
        // @ts-ignore
        (this as InstanceType<typeof ClipMixin>).createClip({
          event_detail_id: null,
          experience_id: this.eventExperience.id
        });
      } else if (this.eventExperience.clip_id) {
        // @ts-ignore
        (this as InstanceType<typeof ClipMixin>).deleteClip({
          clip_id: this.eventExperience.clip_id
        });
      }
    }
  }
});
